import { z } from 'zod';

export const adminEntityCursorSchema = z.object({
    t: z.literal('updated'),
    ts: z.number().int().nonnegative(),
    id: z.string().uuid(),
    fence: z.number().int().positive().optional(),
});

export type AdminEntityCursorSchema = z.infer<typeof adminEntityCursorSchema>;
